/* eslint-disable no-unused-vars */
// import {
//   useSessionList,
//   useTransactionLogsByTID,
// } from '../../../utils/queries/chargingSessions';
// import TransactionLogs from '../../Charger/TransactionLogs';
import { formatDate } from '../../../utils/dateUtils';
import {
  useFetchAllCorporateSessions,
  useFetchCorporateSessionsByUserId,
} from '../../../utils/queries/corporateChargingSessions';
import { useState } from 'react';
import { Table, Typography, Tag, Popover } from 'antd';
import { createUseStyles } from 'react-jss';
import { Link } from 'react-router-dom';
import { FaClipboardList } from 'react-icons/fa';
import { get, toNumber } from 'lodash-es';

const { Text, Title } = Typography;

const useStyles = createUseStyles({
  onlineOfflineBadgeIcon: {
    '& .ant-badge-status-dot': {
      height: '11px',
      width: '11px',
    },
  },
});

export default function UserChargingSessions({ userId, email, phone }) {
  const [offset, setOffset] = useState(1);
  const limit = 10;
  const { data, isLoading, isError } = useFetchCorporateSessionsByUserId({
    userId,
    offset,
    limit,
  });

  const [transactionRequest, setTransactionRequest] = useState({
    cpid: '',
    tid: '',
  });

  const logs = [];
  // const {
  //   data: logs,
  //   isLoading: isLogsLoading,
  //   isError: isLogsError,
  //   refetch,
  // } = useTransactionLogsByTID(transactionRequest);

  // const getContentForLogs = (cpid, tid) => (
  //   <TransactionLogs cpid={cpid} transactionId={tid} />
  // );

  const expandLogs = (cpid, tid) => {
    transactionRequest.current = {
      cpid,
      tid,
    };
    setTransactionRequest({ cpid, tid });
    // setTimeout(() => refetch(), 100);
  };

  const getLogsPopover = (cpid, tid) => (
    <Popover
      placement="bottomLeft"
      content=""
      // content={getContentForLogs(cpid, tid)}
      title={`ChargerId: ${cpid}  |     TransactionId: ${tid}`}
      trigger="click"
    >
      <FaClipboardList
        onClick={() => {
          expandLogs(cpid, tid);
        }}
        style={{
          marginRight: 'auto',
          color: '#2675b8',
          marginBottom: '3px',
          fontSize: 20,
          cursor: 'pointer',
        }}
      />
    </Popover>
  );

  const columns = [
    // {
    //   title: 'Logs',
    //   dataIndex: '',
    //   key: 'x',
    //   width: 80,
    //   render: (text, session) =>
    //     getLogsPopover(session?.CPID, session?.TRANSACTIONID),
    // },
    {
      title: 'Transaction ID',
      dataIndex: 'TRANSACTIONID',
      render: (text, session) => (
        <>
          <Link to={`/corporate/session/${session?.QUEUEID}`}>
            {session?.TRANSACTIONID}
          </Link>
        </>
      ),
      key: 'TRANSACTIONID',
      width: 150,
    },
    {
      title: 'Energy Consumed',
      dataIndex: 'QUEUEID',
      render: (name, session) => (
        <>
          <Text>
            {session?.KWH_CONSUMED
              ? toNumber(session?.KWH_CONSUMED)?.toFixed(2)
              : 0}
            kWh
          </Text>
        </>
      ),
      key: 'QUEUEID',
      width: 150,
    },
    {
      title: 'UserId',
      dataIndex: 'QUEUEID',
      render: (name, session) => (
        <>
          <Text> - </Text>
        </>
      ),
      key: 'QUEUEID',
      width: 150,
    },
    {
      title: 'Charger Id',
      dataIndex: 'CPID',
      render: (name, cp) => (
        <>
          <Link
            to={`/corporate/charger/detail/${get(
              cp,
              'JP_CORPORATE_LOCATION.JP_CORPORATE',
            )}/${get(cp, 'ID')}/${get(cp, 'JP_CORPORATE_CHARGER.ID')}`}
          >
            {cp?.CPID}
          </Link>
        </>
      ),
      key: 'CPID',
      width: 260,
    },
    {
      title: 'Connector',
      dataIndex: 'CONNECTORID',
      render: (name, session) => <>{session?.CONNECTORID}</>,
      width: 110,
      key: 'CONNECTORID',
      align: 'center',
    },
    {
      title: 'Started at',
      dataIndex: 'START_TIME',
      render: (name, session) => <>{formatDate(session?.START_TIME)}</>,
      key: 'START_TIME',
      width: 170,
    },
    {
      title: 'Ended at',
      dataIndex: 'END_TIME',
      render: (name, session) => (
        <>
          {session?.END_TIME ? (
            formatDate(session?.END_TIME)
          ) : (
            <Tag color="green" style={{ fontSize: '15px' }}>
              Charging
            </Tag>
          )}
        </>
      ),
      key: 'END_TIME',
      width: 170,
    },
  ];

  const getTitle = () => (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }}
    >
      <Title level={4} style={{ paddingBottom: 2 }}>
        Charging Sessions ({`${phone}${email ? ', ' + email : ''}`})
      </Title>
    </div>
  );

  return (
    <>
      <Table
        columns={columns}
        dataSource={data?.list}
        scroll={{ y: '70vh' }}
        loading={isLoading}
        rowKey="TRANSACTIONID"
        title={() => getTitle()}
        // pagination={{
        //   // current: 1,
        //   defaultCurrent: 1,
        //   pageSize: limit,
        //   total: data?.total,
        //   showSizeChanger: false,
        //   hideOnSinglePage: limit >= data?.total,
        // }}
        onChange={(pagination, filters, sorter) => {
          setOffset(pagination?.current);
        }}
      />
    </>
  );
}
